import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";

export default () => {
  const { SidebarRenderView } = useStateGetter();

  return (
    <div className="w-full">
    {  SidebarRenderView }
    </div>
  );
};
